// extracted by mini-css-extract-plugin
export default {"rowContainer":"Content_rowContainer__HaKtb","twoColumn":"Content_twoColumn__OTl6u"};